"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.utils = void 0;
exports.utils = {
    width: {
        full: '100%',
    },
    height: {
        full: '100%',
    },
    order: {
        first: -1,
        last: 9999,
    },
};
//# sourceMappingURL=utils.js.map